import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'xvi-xux-form-panel',
  templateUrl: 'xux-form-panel.component.html',
  styleUrls: ['xux-form-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XVIXuxFormPanelComponent implements OnChanges {
  @Input() public title: string = '';
  @Input() public titleTips: string = '';
  @Input() public iconClass: string = '';
  @Input() public description: string = '';
  @Input() public panelId: string = '';
  @Input() public safeDescription: SafeHtml = '';
  @Input() public required: boolean = false;

  public constructor(private sanitizer: DomSanitizer) {}

  public ngOnChanges(): void {
    this.safeDescription = this.sanitizer.sanitize(1, this.description);
  }
}
